<tyt-pricing-prompt-offers
    [headLine]="offerSet.profile_prompt_subtitle"
    [caption]="offerSet.profile_prompt_details"></tyt-pricing-prompt-offers>

<div class="signup-container">
    <ng-container *ngIf="submitting">
        <div class="loading">
            <app-spinner></app-spinner>
            <h1>{{submittingMessage}}</h1>
        </div>
    </ng-container>
    <ng-container *ngIf="!submitting">

        <ng-container *ngIf="mode === 'reset:done'">
            <h1>Check your Email</h1>
            <p>
                We've sent you an email to help you reset your password!
                You'll be able to continue the purchase process from there!
            </p>
        </ng-container>
        <ng-container *ngIf="mode === 'reset'">

            <div class="already-have-account c2a-header">
                <div class="c2a-header-layout">
                    <h1 class="c2a-header-content">
                        <mat-icon>person_add</mat-icon>
                        Need an account?
                    </h1>

                    <a class="btn" href="javascript:;" (click)="goToSignUp()">Sign Up</a>
                </div>
            </div>

            <div class="c2a-header">
                <div class="c2a-header-layout">
                    <h1 class="c2a-header-content">
                        <mat-icon>account_box</mat-icon>
                        Forgot password
                    </h1>
                </div>
            </div>

            <app-form #form [handler]="this" (submit)="resetPassword()">
                <div *ngIf="error" class="alert alert-danger">
                    {{errorMessage}}
                </div>

                <p>Enter your email address below to reset your password.
                    If we have an account on file, you will receive an email
                    allowing you to reset your password and continue with your purchase.
                </p>
                <input type="email"
                    name="email"
                    placeholder="Email address"
                    autocomplete="email"
                    [(ngModel)]="signInEmail"
                    class="form-control"
                    />

                <button>Reset Password</button>
                <button type="button" (click)="goToSignIn()">Cancel</button>


            </app-form>
        </ng-container>
        <ng-container *ngIf="mode === 'signin'">

            <div class="already-have-account c2a-header">
                <div class="c2a-header-layout">
                    <h1 class="c2a-header-content">
                        <mat-icon>person_add</mat-icon>
                        Need an account?
                    </h1>

                    <a class="btn" href="javascript:;" (click)="goToSignUp()">Sign Up</a>
                </div>
            </div>

            <div class="c2a-header">
                <div class="c2a-header-layout">
                    <h1 class="c2a-header-content">
                        <mat-icon>account_box</mat-icon>
                        Welcome back! Sign in below to continue.
                    </h1>
                </div>
            </div>


            <h2>Sign In</h2>
            <form (submit)="signIn()">
                <div *ngIf="error" class="alert alert-danger">
                    {{errorMessage}}
                </div>

                <input type="email"
                    name="email"
                    placeholder="Email address"
                    autocomplete="email"
                    [(ngModel)]="signInEmail"
                    class="form-control"
                    />
                <input type="password"
                    name="password"
                    placeholder="Password"
                    autocomplete="new-password"
                    [(ngModel)]="signInPassword"
                    class="form-control"
                    />


                <button>Continue</button>

                <div class="already-have-account">
                    <a href="javascript:;" (click)="goToReset()">Forgot password</a>
                </div>

                <div class="signup-with">
                    <img src="/assets/offers/signup-with-black.png">
                    <span>Or Sign In With</span>
                    <div class="divisor-line"></div>
                </div>
                <div *ngFor="let option of externalSignupOptions" class="signup-option">
                    <a [href]="oauthUrlFor(option.id)" [attr.aria-label]="option.alt">
                        <img src="{{ option.image }}" [alt]="option.alt">
                    </a>
                </div>

            </form>

        </ng-container>

        <ng-container *ngIf="mode === 'signup'">

            <ng-container *ngIf="ytcmMigrationOffer">
                <h1>Set up your TYT account</h1>
                <p>In order to receive this offer, your TYT account must be connected to your YouTube account.</p>
                <ul>
                    <li>If you do not have an existing TYT account, you can sign in via your YouTube account below.</li>
                    <li>If you have a TYT account already, sign in and connect your YouTube account by visiting
                        <a target="_blank" [href]="accountSettingsUrl">Connected Accounts</a>.
                    </li>
                    <li>If your YouTube account is already connected to your TYT account,
                    use Sign In with Youtube below to continue.</li>
                </ul>

                <br/>
                <br/>

                <div class="social-buttons" style="margin: auto;">
                    <ng-container *ngFor="let option of externalSignupOptions">
                        <div class="signup-option" *ngIf="option.id === 'youtube'">
                            <a [href]="oauthUrlFor(option.id)" [attr.aria-label]="option.alt">
                                <img src="{{ option.image }}" [alt]="option.alt">
                            </a>
                        </div>
                    </ng-container>
                </div>

                <br/>
                <br/>

                Understand that this offer is only available if all of the following are true:

                <ul>
                    <li>You have a TYT Supporter membership on YouTube ($1.99/mo)</li>
                    <li>You do not already have another membership on TYT.com or our mobile apps.</li>
                </ul>

                <p>If you have any issues with this process, please reach out to support@tytnetwork.com and we'll help
                    you get it sorted out! Thanks for supporting TYT!</p>

            </ng-container>
            <ng-container *ngIf="!ytcmMigrationOffer">
                <div class="already-have-account c2a-header">
                    <div class="c2a-header-layout">
                        <h1 class="c2a-header-content" aria-role="header">
                            <mat-icon>account_box</mat-icon>
                            Already have an account?
                        </h1>

                        <a class="btn" href="javascript:;" (click)="goToSignIn()">Sign In</a>
                    </div>
                </div>

                <div class="c2a-header">
                    <div class="c2a-header-layout">
                        <h1 class="c2a-header-content">
                            <mat-icon>person_add</mat-icon>
                            New to TYT? Make an account now.
                        </h1>
                    </div>
                </div>

                <div *ngIf="error" class="alert alert-danger">
                    {{errorMessage}}
                </div>

                <app-form #form [handler]="this" (submit)="submit()">
                    <input type="text"
                        id="firstName"
                        name="firstName"
                        errorHighlight
                        [(ngModel)]="firstName"
                        class="form-control"
                        placeholder="First Name"
                        autocomplete="given-name"
                        />
                    <input
                        type="email"
                        id="email"
                        errorHighlight
                        name="email"
                        [(ngModel)]="email"
                        class="form-control"
                        autocomplete="email"
                        placeholder="Email Address"
                        />
                    <input
                        type="password"
                        id="password"
                        errorHighlight
                        name="password"
                        [(ngModel)]="password"
                        class="form-control"
                        placeholder="Password"
                        autocomplete="new-password"
                        />
                    <input
                        type="text"
                        id="username"
                        errorHighlight
                        name="username"
                        [(ngModel)]="username"
                        class="form-control"
                        placeholder="Username"
                        autocomplete="username"
                        />
                    <input
                        type="text"
                        id="phoneNumber"
                        errorHighlight
                        name="phoneNumber"
                        [(ngModel)]="phoneNumber"
                        class="form-control"
                        placeholder="Phone Number (Optional)"
                        autocomplete="phoneNumber"
                        />
                    <span>
                        {{ smsAgreement }}
                        <br/><br/>
                    </span>
                    <input
                        type="number"
                        id="zipCode"
                        name="zipCode"
                        errorHighlight
                        [(ngModel)]="zipCode"
                        class="form-control"
                        autocomplete="postal-code"
                        placeholder="US Zip Code (Optional)"
                        />

                    <div class="terms-agreement">
                        <input
                        type="checkbox"
                        id="termsAgreement"
                        name="termsAgreement"
                        [(ngModel)]="termsAgreement"
                        />
                        <label for="termsAgreement">
                            By signing up via any of the above methods, you agree to TYT's <a href="/terms" target="_blank">Terms of Use</a>, <a href="/privacy" target="_blank">Privacy Policy</a> and <a href="/core-values" target="_blank">Core Values</a>.
                        </label>
                    </div>

                    <tyt-optins [optins]="optins" [includePremium]="true"></tyt-optins>

                    <div *ngIf="showRecaptchaOnSignup" class="captcha-row">
                        <re-captcha
                            name="recaptcha"
                            (resolved)="captchaSolved($event)"
                            [siteKey]="recaptchaSiteKey"
                        >
                            </re-captcha>
                        <span *ngIf="checkKeyOnFieldErrorsArray('recaptcha')">Please validate the reCaptcha</span>
                    </div>

                    <button [disabled]="!isFormValid" class="submit">Create my Profile</button>

                    <div class="signup-with">
                        <img src="/assets/offers/signup-with-black.png">
                        <span>Or sign up with</span>
                    </div>
                    <div class="social-buttons">
                        <div *ngFor="let option of externalSignupOptions" class="signup-option">
                            <a [href]="oauthUrlFor(option.id)" [attr.aria-label]="option.alt">
                                <img src="{{ option.image }}" [alt]="option.alt">
                            </a>
                        </div>
                    </div>
                </app-form>
            </ng-container> <!-- ytcmMigrationOffer -->
        </ng-container>
    </ng-container>
</div>
